import React, { memo } from "react";
import isempty from "lodash/isEmpty";
import type { tTaskServiceMeta } from "@/types";

type tProps = {
  services: tTaskServiceMeta[];
};
const Services = ({ services }: tProps) => {
  if (isempty(services)) {
    return null;
  }
  return (
    <ul
      css={`
        overflow-wrap: anywhere;
        li {
          padding-bottom: 5px;
        }
      `}
    >
      {services.map(({ service, title, amount }) => (
        <li key={service}>
          <div>
            <span>{title}</span>
            {amount && (
              <span
                css={`
                  font-weight: 700;
                  font-size: 14px;
                  span:first-child {
                    color: var(--color-danger);
                  }
                `}
              >
                {" "}
                <span>x</span> <span>{amount}</span>
              </span>
            )}
          </div>
        </li>
      ))}
    </ul>
  );
};

export default memo(Services);
